(function () {
  function initSGRGalleryArrows(gallery) {
    if (!gallery || gallery.dataset.sgrArrowsInitialized === 'true') return;

    const controls = gallery.querySelector('[data-sgr-gallery-arrows]');
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');

    if (!controls || !viewer) return;
    if (typeof gallery.setActiveMedia !== 'function') return;

    const previousButton = controls.querySelector('[data-sgr-gallery-prev]');
    const nextButton = controls.querySelector('[data-sgr-gallery-next]');

    if (!previousButton || !nextButton) return;

    /*
     * Product.media order is stored in Liquid so variant changes
     * cannot disturb the intended carousel order.
     */
    const originalMediaOrder = controls.dataset.mediaOrder
      .split('|')
      .filter(Boolean);

    function getAvailableMedia() {
      const mediaElements = Array.from(
        viewer.querySelectorAll('[data-media-id]')
      );

      return originalMediaOrder.filter((mediaId) =>
        mediaElements.some(
          (element) => element.dataset.mediaId === mediaId
        )
      );
    }

    function getActiveMediaId() {
      const activeMedia = viewer.querySelector(
        '[data-media-id].is-active'
      );

      if (activeMedia) {
        return activeMedia.dataset.mediaId;
      }

      const availableMedia = getAvailableMedia();
      return availableMedia[0];
    }

    function moveGallery(direction) {
      const availableMedia = getAvailableMedia();

      if (availableMedia.length < 2) return;

      const currentMediaId = getActiveMediaId();
      let currentIndex = availableMedia.indexOf(currentMediaId);

      if (currentIndex === -1) {
        currentIndex = 0;
      }

      let newIndex = currentIndex + direction;

      /*
       * Wrap carousel:
       * Last image -> Next -> First image
       * First image -> Previous -> Last image
       */
      if (newIndex < 0) {
        newIndex = availableMedia.length - 1;
      }

      if (newIndex >= availableMedia.length) {
        newIndex = 0;
      }

      const newMediaId = availableMedia[newIndex];

      gallery.setActiveMedia(newMediaId, false);
    }

    previousButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      moveGallery(-1);
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      moveGallery(1);
    });

    /*
     * Only display the arrows when at least two
     * media items are actually available.
     */
    if (getAvailableMedia().length > 1) {
      controls.hidden = false;
    }

    gallery.dataset.sgrArrowsInitialized = 'true';
  }

  function initializeAllGalleries() {
    document
      .querySelectorAll('media-gallery')
      .forEach(initSGRGalleryArrows);
  }

  if (customElements.get('media-gallery')) {
    initializeAllGalleries();
  } else {
    customElements
      .whenDefined('media-gallery')
      .then(initializeAllGalleries);
  }

  /*
   * Makes it work inside Shopify's Theme Editor too.
   */
  document.addEventListener(
    'shopify:section:load',
    initializeAllGalleries
  );
})();